export default {
    setAllAlarms(state, payload) {
        for (const alarm of payload) {
            if (alarm.alarmDeliveryList) {
                for (const user of alarm.alarmDeliveryList) {
                    user.sendEmail = user.isEmailAlarm
                }
            }
        }
        
        state.allAlarms = payload;
    },
    setIndividualAlarms(state, payload) {
        state.individualAlarms = payload;
    },
    setAlarmTypes(state, payload) {
        state.alarmTypes = payload;
    },
    setAlarmAccounts(state, payload) {
        state.alarmAccounts = payload;
    },
    setRule(state, payload) {
        const allAlarms = state.allAlarms.concat(state.individualAlarms);

        let alarm = allAlarms.find(x => x.id == payload.alarmId);

        const ruleArray = [];

        for (const ruleString of payload.expressions) {
            let rule = {};

            if (alarm.typeId == 1 || alarm.typeId == 3 || alarm.typeId == 5 || alarm.typeId == 6 || alarm.typeId == 9) {
                rule = { commonRuleExpression: ruleString };
            } else {
                rule = JSON.parse(ruleString);
            }

            ruleArray.push(rule);
        }

        alarm = { ...alarm, hasRules: true, rules: ruleArray, descriptions: payload.descriptions };

        const stateAlarm = state.allAlarms.find(x => x.id == payload.alarmId);
        const index = state.allAlarms.indexOf(stateAlarm);

        state.allAlarms[index] = alarm;
    },
    setAlarmRule(state, payload) {
        const allAlarms = [...state.allAlarms, ...state.individualAlarms];
        
        const alarm = allAlarms.find(x => x.id == payload.alarmId);

        const ruleArray = [];

        for (const ruleString of payload.expressions) {
            let rule = {};

            if (alarm.typeId == 1 || alarm.typeId == 3 || alarm.typeId == 5 || alarm.typeId == 6 || alarm.typeId == 9) {
                rule = { commonRuleExpression: ruleString };
            } else {
                rule = JSON.parse(ruleString);
            }

            ruleArray.push(rule);
        }

        state.rules = ruleArray;
        state.descriptions = payload.descriptions;
    },
    setAlarmSummary(state, payload) {
        for (const index in payload) {
            if (payload[index].typeId == 1) {
                payload[index] = { ...payload[index], iconName: "bolt" };
            } else if (payload[index].typeId == 4) {
                payload[index] = { ...payload[index], iconName: "storage" };
            } else if (payload[index].typeId == 3 || payload[index].typeId == 5) {
                payload[index] = { ...payload[index], iconName: "target" };
            } else if (payload[index].typeId == 6) {
                payload[index] = { ...payload[index], iconName: "person" };
            } else if (payload[index].typeId == 7) {
                payload[index] = { ...payload[index], iconName: "news" };
            } else if (payload[index].typeId == 8) {
                payload[index] = { ...payload[index], iconName: "favorite" };
            } else if (payload[index].typeId == 9) {
                payload[index] = { ...payload[index], iconName: "manage_accounts" };
            }
        }

        state.alarmSummary = payload;
    }
}